<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.packageCodeName') }}</div>
                <div class="">
                  <input v-model="searchParams.keyword" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.saleDate') }}</div>
                <div class="">
                  <!-- <SingleCalendar
                  v-model="searchParams.startDate"
                  class="use-icon"
                  :date-data="searchParams.startDate"
                /> -->
                  <CalendarSelect
                    v-model="searchParams.startDate"
                    style="display: block"
                    mode="date"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3 flex align-end">
              <div class="das-form-input">
                <div>
                  <div class="checkbox-wrap">
                    <input
                      id="isNonActive"
                      v-model="searchParams.isNonActive"
                      type="checkbox"
                    />
                    <label for="isNonActive">{{
                      $t('views.configuration.showPackageNotWorking')
                    }}</label>
                  </div>
                  <div class="checkbox-wrap mt-10">
                    <input
                      id="isExpired"
                      v-model="searchParams.isExpired"
                      type="checkbox"
                    />
                    <label for="isExpired">{{
                      $t('views.configuration.showPackageExpired')
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <!-- <el-form :inline="true" class="demo-form-inline" style="margin: 20px 0">
      <el-form-item label="Đơn vị">
      </el-form-item>
      <el-form-item label="Mã/Tên gói">
        <el-input placeholder="Nhập thông tin" />
      </el-form-item>
      <el-form-item label="Ngày bán">
        <el-date-picker
          type="date"
          placeholder="Pick a day"
        />
      </el-form-item>
      <el-form-item>
        <el-checkbox>Hiển thị gói đã hết hạn</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-checkbox>Hiển thị gói không hoạt động</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">Tìm kiếm</el-button>
      </el-form-item></el-form> -->

    <!-- START GRID TABLES -->
    <div class="content-box" style="flex: 1">
      <div class="section-box outline" style="height: 100%">
        <div class="das-form-container flex-col" style="height: 66%">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">{{
                $t('views.configuration.package')
              }}</span>
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr style="width: 100%" />
          <div v-loading="packGridLoading" class="grid-scroll">
            <GridVx
              ref="packGrid"
              :columns="packColumns"
              :rows="packRows"
              row-selection="multiple"
              dom-layout="scroll"
              class="agGrid"
              @selectionChanged="onSelectPackRow"
            />
          </div>
          <div class="grid-bottom mt-10">
            <GridPaging
              target="packGrid"
              :total-size="totalPage"
              :page-num="currentPage"
              @pageChanged="onPageChanged"
              @onPageSizeChange="onPageSizeChange"
            />
          </div>
        </div>
        <div class="das-form-container flex-col" style="height: 33%">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"
                >{{ $t('views.configuration.packageDetail') }}
                {{ packRowSelected?.name }}
              </span>
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr style="width: 100%" />
          <div v-loading="packDetailGridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="packDetailGrid"
              :columns="packDetailColumns"
              :rows="packDetailRows"
              dom-layout="scroll"
              class="agGrid"
              @selectionChanged="onSelectPackDetailRow"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- END GRID TABLES -->

    <el-col class="bottom-btns-container">
      <div class="button-containers mb-0">
        <button class="btn primary small outline" @click="deletePackage">
          {{ $t('button.deletePackage') }}
        </button>
        <button class="btn primary small outline" @click="deletePackageDetail">
          {{ $t('button.deletePackageDetail') }}
        </button>
        <button class="btn primary small" @click="openEditDialogPack">
          {{ $t('button.modifyPackage') }}
        </button>
        <button class="btn primary small" @click="openAddDialogPack">
          {{ $t('button.addPackage') }}
        </button>
        <button class="btn primary small" @click="openEditDialogPackDetail">
          {{ $t('button.modifyPackageDetail') }}
        </button>
        <button class="btn primary small" @click="openAddDialogPackDetail">
          {{ $t('button.addPackageDetail') }}
        </button>
      </div>
    </el-col>

    <!-- DIALOGS -->
    <PackageFormDialog
      :is-show="dialogPackFormVisible"
      :is-edit-dialog="isDialogPackEdit"
      :package-id="packRowSelected?.id"
      @close="dialogPackFormVisible = false"
      @addPackage="addPackage"
      @updatePackage="updatePackage"
    />
    <PackageDetailFormDialog
      :is-show="dialogPackDetailVisible"
      :is-edit-dialog="isDialogPackDetailEdit"
      :package-detail-id="packDetailRowSelected?.id"
      :package-info="packRowSelected"
      @close="dialogPackDetailVisible = false"
      @addPackageDetail="addPackageDetail"
      @updatePackageDetail="updatePackageDetail"
    />
  </div>
</template>

<script>
// import bus from '@/utils/bus'
/* eslint-disable */
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import PackageFormDialog from './components/PackageFormDialog.vue'
import PackageDetailFormDialog from './components/PackageDetailFormDialog.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import {
  getPackageApi,
  getPackageApibyId,
  deletePackageApi,
  updatePackageApi,
  addPackageApi
} from '@/api/Service_Policy/package'
import {
  addPackageDetailApi,
  updatePackageDetailApi,
  deletePackageDetailApi
} from '@/api/Service_Policy/packageDetail'
import { getPackageDetailListApi } from '@/api/Service_Policy/packageDetail'
import { getCurrencyListApi, getTransPageListApi } from '@/api/common/code'
import { getPackageCategoryApi } from '@/api/Service_Policy/packageCategory'
import { getTransactionListSimpleApi } from '@/api/Transaction/transaction'
import { getSubTransactionListSimpleApi } from '@/api/Transaction/subTransaction'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderToggleSwitchReadOnly,
    SingleCalendar,
    PackageFormDialog,
    PackageDetailFormDialog,
    CalendarSelect
  },
  data() {
    return {
      packGridLoading: false,
      packDetailGridLoading: false,
      time1: null,
      totalPage: 0,
      currentPage: 0,
      isDialogPackEdit: false,
      isDialogPackDetailEdit: false,
      dialogPackFormVisible: false,
      dialogPackDetailVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        keyword: null,
        startDate: null,
        // useStatus: null,
        // active: null,
        isNonActive: false,
        isExpired: false,
        orderBy: null,
        orderTp: 'ASC'
      },

      transactionOptions: [],
      subTransactionOptions: [],
      transactionPageOptions: [],
      currencyOptions: [],
      categoryPackageptions: [],

      packColumns: [
        // {
        //   headerName: "",
        //   field: "index",
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false,
        // },
        {
          headerName: this.$t('grid.column.packageCode'),
          field: 'code',
          // cellClass: 'grid-cell-centered',
          minWidth: 150,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.packageName'),
          field: 'name',
          minWidth: 150,
          sortable: false
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.startSaleDate'),
          field: 'start_date',
          minWidth: 150,
          maxWidth: 150,
          sortable: false
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.endSaleDate'),
          field: 'end_date',
          minWidth: 150,
          maxWidth: 150,
          sortable: false
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.transactionNameCode'),
          field: 'transaction_name',
          minWidth: 160,
          sortable: false
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.subTransactionNameCode'),
          field: 'sub_transaction_name',
          minWidth: 160,
          sortable: false

          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.frequencyUse'),
          field: 'frequency_use',
          // cellClass: 'grid-cell-centered',
          valueGetter: params => {
            switch (params.data.frequency_use) {
              case 1:
                return this.$t('views.configuration.addTransactionNightly')
              case 2:
                return this.$t('views.configuration.addTransactionDaily')
              case 3:
                return this.$t(
                  'views.configuration.addTransactionExceptFirstDay'
                )
              case 4:
                return this.$t('views.configuration.addTransactionOnFirstDay')
              case 5:
                return this.$t('views.configuration.addTransactionOnLastDay')
            }
          },
          minWidth: 300,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.billingRule'),
          field: 'billing_rule',
          // cellClass: 'grid-cell-centered',
          valueGetter: params => {
            switch (params.data.billing_rule) {
              case 1:
                return this.$t('views.configuration.fixedPrice')
              case 2:
                return this.$t('views.configuration.adultAndChild')
              case 3:
                return this.$t('views.configuration.adult')
              case 4:
                return this.$t('views.configuration.child')
            }
          },
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.active
            }
          },
          minWidth: 100,
          maxWidth: 100,
          sortable: false
          // width: 90,
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.packageGroupCode'),
          field: 'package_group_codes',
          tooltipField: 'package_group_codes',
          minWidth: 150,
          sortable: false
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.priceCode'),
          field: 'price_codes',
          tooltipField: 'price_codes',
          minWidth: 150,
          sortable: false
          // cellClass: 'grid-cell-centered'
        }
      ],
      packRows: [],
      packDetailColumns: [
        {
          headerName: this.$t('grid.column.codeDetail'),
          field: 'code',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.effectiveDate'),
          field: 'effective_date',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.expiryDate'),
          field: 'expiration_date',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.applicableDaysInWeek'),
          field: 'applicable_day',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.applicablePeopleAmount'),
          cellRenderer: params => {
            if (
              params.data.min_apply_people !== null &&
              params.data.min_apply_people !== undefined &&
              params.data.max_apply_people !== null &&
              params.data.max_apply_people !== undefined
            ) {
              return (
                params.data.min_apply_people +
                ' - ' +
                params.data.max_apply_people
              )
            }
          },
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.applicableNightAmount'),
          cellRenderer: params => {
            if (
              params.data.min_night !== null &&
              params.data.min_night !== undefined &&
              params.data.max_night !== null &&
              params.data.max_night !== undefined
            ) {
              return params.data.min_night + ' - ' + params.data.max_night
            }
          }, // cellClass: 'grid-cell-centered',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.price'),
          field: 'unit_price',
          // cellClass: 'grid-cell-centered',
          cellRenderer: params => {
            return !isNaN(params.value)
              ? params.value.toLocaleString('en-US')
              : ''
          },
          minWidth: 100,
          sortable: false
        },
        {
          headerName: 'Phân loại',
          field: 'is_adult',
          // cellClass: 'grid-cell-centered',
          cellRenderer: params => {
            return params.value ? 'Người lớn' : 'Trẻ em'
          },
          minWidth: 100,
          sortable: false
        }
      ],
      packDetailRows: [],
      packRowSelected: null,
      packDetailRowSelected: null,

      // FOR DISABLING BUTTONS
      disableEditPack: true,
      disableDeletePack: true,
      disableEditPackDetail: true,
      disableDeletePackDetail: true
    }
  },
  watch: {},
  beforeMount() {
    // this.getTransactionOptions();
    // this.getCurrencyOptions();
    // this.getTransactionPageOptions();
    // this.getPackageCategoryOptions();
  },

  mounted() {
    this.attachData()

    // GET GRID API
    this.packGridApi = this.$refs.packGrid.gridApi
    this.packDetailGridApi = this.$refs.packDetailGrid.gridApi
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },

    async fnGetPackageDetailList(packageId) {
      if (packageId) {
        this.packDetailGridLoading = true
        await getPackageDetailListApi({ packageId })
          .then(res => {
            this.packDetailRows = res.data
          })
          .finally(() => {
            this.packDetailGridLoading = false
          })
      } else {
        this.packDetailRows = null
      }
    },

    onReset() {
      this.searchParams = {
        ...this.searchParams,
        keyword: null,
        startDate: null,
        // useStatus: null,
        // active: null,
        isNonActive: false,
        isExpired: false,
        orderBy: null,
        orderTp: 'ASC',
        pageNum: 1
      }
      this.attachData()
    },

    onSearch() {
      this.attachData()
    },

    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.packGridLoading = true
      let data = await getPackageApi(this.searchParams)
      // bus.$emit('endLoader')
      this.packGridLoading = false
      this.packRows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
      if (!data.data?.length) {
        // RESET pack detail list
        this.packRowSelected = null
        this.packDetailRows = null
      }
    },

    addPackage(data) {
      const { payload, isAddDetail } = data
      addPackageApi(payload)
        .then(async res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          await this.attachData()
          this.dialogPackFormVisible = false

          if (isAddDetail) {
          }
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    updatePackage(data) {
      const { payload } = data
      updatePackageApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
          this.dialogPackFormVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    addPackageDetail(data) {
      const { payload } = data
      addPackageDetailApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.fnGetPackageDetailList(this.packRowSelected?.id)
          this.dialogPackDetailVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    updatePackageDetail(data) {
      const { payload } = data
      updatePackageDetailApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.fnGetPackageDetailList(this.packRowSelected?.id)
          this.dialogPackDetailVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deletePackage() {
      const selectedRows = this.packGridApi.getSelectedRows()
      if (!selectedRows?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackage'),
          type: 'error'
        })
        return
      }

      this.$vxConfirm(this.$t('alert.deletePackage'), {
        resolveText: 'OK',
        rejectText: 'Cancel',
        resolve: () => {
          const idList = selectedRows.map(item => item.id)
          deletePackageApi({ id_list: idList })
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('successMsg.' + res.message)
              })
              this.attachData()
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + err.response.data.message)
              })
            })
        }
      })
    },
    async deletePackageDetail() {
      const selectedRows = this.packDetailGridApi.getSelectedRows()
      if (!selectedRows?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackageDetail'),
          type: 'error'
        })
        return
      }

      this.$vxConfirm(this.$t('alert.deletePackageDetail'), {
        resolveText: 'OK',
        rejectText: 'Cancel',
        resolve: () => {
          const idList = selectedRows.map(item => item.id)
          deletePackageDetailApi({ id_list: idList })
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('successMsg.' + res.message)
              })
              this.fnGetPackageDetailList(this.packRowSelected.id)
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + err.response.data.message)
              })
            })
        }
      })
    },

    onSelectPackRow(rows) {
      this.packRowSelected = rows?.length == 1 ? rows?.[0] : null
      this.fnGetPackageDetailList(this.packRowSelected?.id)
    },

    onSelectPackDetailRow(rows) {
      this.packDetailRowSelected = rows?.[0]
    },

    // DIALOG ACTION
    openAddDialogPack() {
      this.dialogPackFormVisible = true
      this.isDialogPackEdit = false
    },
    openEditDialogPack() {
      const selectedRows = this.packGridApi.getSelectedRows()
      if (!selectedRows?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackage'),
          type: 'error'
        })
      } else if (selectedRows.length !== 1) {
        this.$message({
          message: this.$t('errorMsg.selectOnePackageOnly'),
          type: 'error'
        })
      } else {
        this.dialogPackFormVisible = true
        this.isDialogPackEdit = true
      }
    },
    openAddDialogPackDetail() {
      const selectedRows = this.packGridApi.getSelectedRows()
      if (!selectedRows?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackage'),
          type: 'error'
        })
      } else if (selectedRows.length !== 1) {
        this.$message({
          message: this.$t('errorMsg.selectOnePackageOnly'),
          type: 'error'
        })
      } else {
        this.dialogPackDetailVisible = true
        this.isDialogPackDetailEdit = false
      }
    },
    openEditDialogPackDetail() {
      const selectedRows = this.packDetailGridApi.getSelectedRows()
      if (!selectedRows?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackageDetail'),
          type: 'error'
        })
      } else if (selectedRows.length !== 1) {
        this.$message({
          message: this.$t('errorMsg.selectOnePackageDetailOnly'),
          type: 'error'
        })
      } else {
        this.dialogPackDetailVisible = true
        this.isDialogPackDetailEdit = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
